import {
    commonReducer,
    initialCommonState,
    type commonState,
    type commonAction,
} from "@/hooks/reducers/common.reducer";
import type { loginFormData } from "./types.api";
import type { parsedApiError } from "@/types/api/errors.api";

export interface loginFormState extends commonState {
    formData: loginFormData;
    passwordVisibility: boolean;
    loginStatusMessage: string;
}

export const initialState: loginFormState = {
    ...initialCommonState,
    formData: { email: "", password: "" },
    passwordVisibility: false,
    loginStatusMessage: "",
};

type action =
    | commonAction
    | { type: "SET_FIELD"; field: keyof loginFormData; value: string }
    | { type: "TOGGLE_PASSWORD_VISIBILITY" }
    | { type: "SET_STATUS_MESSAGE"; message: string }
    | { type: "SET_FORM_ERRORS"; payload: parsedApiError }
    | { type: "RESET_FORM" };

export const loginFormReducer = (
    state: loginFormState,
    action: action,
): loginFormState => {
    const commonState = commonReducer(state, action as commonAction);
    const baseState = {
        ...state,
        ...commonState,
    };

    switch (action.type) {
        case "SET_FIELD":
            return {
                ...baseState,
                error: null,
                formData: { ...state.formData, [action.field]: action.value },
            };
        case "TOGGLE_PASSWORD_VISIBILITY":
            return {
                ...baseState,
                passwordVisibility: !state.passwordVisibility,
            };
        case "SET_FORM_ERRORS":
            return {
                ...baseState,
                error: action.payload,
            };
        case "SET_STATUS_MESSAGE":
            return { ...baseState, loginStatusMessage: action.message };
        case "RESET_FORM":
            return initialState;
        default:
            return baseState;
    }
};
